// 导入类型，并非App对象
// import type { App, Plugin } from 'vue';
/**
 * 组件外部使用use时执行install
 */

// 导出类型，否则生成不了.d.ts文件
// export type SFCInstall<T> = T & Plugin;

export const install = (comp) => {
    comp.install = function (app) {
        app.component(comp.name, comp);
    };
    return comp;
};
